import { Component } from '@angular/core';
import { TitleService } from '../../../services/title.service';

@Component({
  selector: 'app-return-exchange-policy-page',
  imports: [],
  templateUrl: './return-exchange-policy-page.html',
  styleUrl: './return-exchange-policy-page.scss',
})
export class ReturnExchangePolicyPage {
  constructor(private titleService: TitleService) {
    this.titleService.setTitle('Return & Exchange Policy');
  }
}
